import type { AppStateKind } from '@otryad/shared';

import { trpc } from './trpc';

export interface AppFeatures {
  /** `feature.myGatherings` (Stage 17): вкладка «Мои сборы», заявки, панель у человека в пуле */
  myGatherings: boolean;
  state: AppStateKind | null;
}

/**
 * Флаги каркаса из `auth.me` (Stage 17, задача 7). `auth.me` уже загружен гейтом на старте, поэтому
 * отдельного запроса нет; пока ответа нет, флаг считается выключенным — экраны как в rc.30.
 */
export function useAppFeatures(): AppFeatures {
  const me = trpc.auth.me.useQuery(undefined, { staleTime: 60_000 });
  return {
    myGatherings: me.data?.features.myGatherings ?? false,
    state: me.data?.state ?? null,
  };
}
